<div class="sidebar-wrapper" [class.collapsed]="isCollapsed">
  <div class="sidebar-header">
    <div class="app-logo">
      @if (cabangaLite) {
        <div class="logo-icon">
          <mat-icon>how_to_reg</mat-icon>
        </div>
        <span class="logo-text">Horizon - Présences</span>
      } @else {
        <div class="logo-icon">
          <img src="assets/icons/icon-128x128.png" alt="Cabanga logo" class="logo-img"/>
        </div>
        <span class="logo-text">Cabanga</span>
      }
    </div>
  </div>
  <div class="sidebar-nav">
    <mat-nav-list>
      @for (item of menuItems; track item.dataCy ?? item.label) {
      @if (item.kind === 'link' && item.condition !== false) {
      <a mat-list-item [routerLink]="item.route" [attr.routerLink]="item.route" routerLinkActive="active"
        (click)="menuSelected()" [attr.data-cy]="item.dataCy">
        @if (item.icon) {
        <mat-icon matListItemIcon>{{item.icon}}</mat-icon>
        }
        <div matListItemTitle>{{item.label}}</div>
      </a>
      } @else if (item.kind === 'group' && item.condition !== false && isCollapsed === false) {
      <mat-accordion>
        <mat-expansion-panel class="mat-elevation-z0">
          <mat-expansion-panel-header>
            <div [attr.data-cy]="item.sectionDataCy">
              <mat-icon>{{item.icon}}</mat-icon>
              <span matListItemTitle [attr.data-cy]="item.dataCy">{{item.label}}</span>
            </div>
          </mat-expansion-panel-header>
          @for (link of item.links; track link.dataCy) {
          @if (link.condition !== false) {
          <a mat-list-item [routerLink]="link.route" [attr.routerLink]="link.route" routerLinkActive="active"
            (click)="menuSelected()" [attr.data-cy]="link.dataCy">
            <div matListItemTitle>{{link.label}}</div>
          </a>
          }
          }
        </mat-expansion-panel>
      </mat-accordion>
      } @else if (item.kind === 'group' && item.condition !== false && isCollapsed === true) {
      <a mat-list-item [matMenuTriggerFor]="menu" [matMenuTriggerData]="{item}" [attr.data-cy]="item.dataCy"
        [matTooltip]="isCollapsed ? item.label : ''" matTooltipPosition="right">
        <mat-icon matListItemIcon>{{item.icon}}</mat-icon>
        <div matListItemTitle>{{item.label}}</div>
      </a>
      }
      }
      <mat-menu #menu="matMenu">
        <ng-template matMenuContent let-item="item">
          @for (link of item.links; track link.dataCy) {
          @if (link.condition !== false) {
          <button mat-menu-item [routerLink]="link.route" (click)="menuSelected()" [attr.data-cy]="link.dataCy">
            <span>{{ link.label }}</span>
          </button>
          }
          }
        </ng-template>
      </mat-menu>
    </mat-nav-list>
  </div>
  @if (isMobile === false) {
  <div class="sidebar-footer">
    <div class="toggle-container" [class.collapsed]="isCollapsed">
      <button class="toggle-button" (click)="toggleCollapse()">
        <mat-icon>{{ isCollapsed ? 'chevron_right' : 'chevron_left' }}</mat-icon>
        <span class="toggle-label">Réduire la navigation</span>
      </button>
    </div>
  </div>
  }
</div>